import React from 'react';

interface ControlsBarProps {
  paused: boolean;
  onTogglePause: () => void;
}

// Ultra minimal bar: just the word "ESPACE" in a tiny pill. Clicking still toggles pause silently.
const ControlsBar: React.FC<ControlsBarProps> = ({ paused, onTogglePause }) => {
  return (
    <div
      onClick={onTogglePause}
      className={`controls-bar-container ${paused ? 'controls-bar-paused' : ''}`}
      title={paused ? 'Reprendre (Espace)' : 'Mettre en pause (Espace)'}
    >
      ESPACE
    </div>
  );
};

export default ControlsBar;